import { Typography } from '@mui/material'
import React from 'react'

export const SplashPage = () => <Typography variant="h1">Loading</Typography>
